<template>
  <div class="shouye">
	<div class="navList">
		<!-- 顶级导航：热门=直播列表；短视频=短影音列表，其下方还有分类：全部/热门 -->
		<div class="navList-item" v-for="(item,index) in topNavList" :key="index" @click="handleTopNav(index)">
			<span :class="topNavIndex===index?'navList-item-span':'navList-item-span1'">{{item}}</span>
			<span :class="topNavIndex===index?'navList-item-xian':'navList-item-xian1'"></span>
		</div>
	</div>
	<!-- 二级分类（胶囊样式）：热门tab下是直播分类；短视频tab下是 全部/热门 -->
	<div class="subNavList">
		<template v-if="topNavIndex===0">
			<div class="subNavList-item" :class="navListIndex===index?'subNavList-item-active':''" v-for="(item,index) in navList" :key="'live'+index" @click="handleNav(index)">
				<span :class="navListIndex===index?'subNavList-item-span':'subNavList-item-span1'">{{item.categoryName}}</span>
			</div>
		</template>
		<template v-else>
			<div class="subNavList-item" :class="videoCateIndex===index?'subNavList-item-active':''" v-for="(item,index) in videoCateList" :key="'video'+index" @click="handleVideoCate(index)">
				<span :class="videoCateIndex===index?'subNavList-item-span':'subNavList-item-span1'">{{item.categoryName}}</span>
			</div>
		</template>
	</div>
	<!-- 直播：网格列表 + 滚动加载 -->
	<div class="list" ref="listContainer" v-show="topNavIndex===0" @scroll="handleScroll">
		<div class="list-box">
			<zbList v-for="(item,index) in list" :key="index" :data="item"></zbList>
		</div>
		<kong v-if="isKong"></kong>
	</div>
	<!-- 短视频：封面网格列表（点击进播放详情，bofangshipin 内 duanshippin 竖屏播放） -->
	<div class="video-grid-wrap" v-if="topNavIndex===1" ref="videoGridContainer" @scroll="handleVideoScroll">
		<div class="video-grid" v-if="videoList.length > 0">
			<div class="video-item" v-for="(item,index) in videoList" :key="item.videoId || item.id || index" @click="handlePlayVideo(item)">
				<img class="video-item-img" :src="item.coverUrl" />
				<div class="video-item-content">
					<div class="video-item-content-text">
						<span class="video-item-content-title">{{item.title || ''}}</span>
						<span class="video-item-content-desc">{{item.nickName || ''}}</span>
					</div>
					<span class="video-item-content-duration">{{item.duration ? formatDuration(item.duration) : '00:00'}}</span>
				</div>
			</div>
		</div>
		<kong v-if="videoLoaded && !videoLoading && videoList.length === 0"></kong>
	</div>
  </div>
</template>

<script>
import { getLiveList, getLiveCategoryList,checkIsLogin } from "@/api/zhibo";
import { getAppConfigInfo, getVideoList } from "@/api/user";
import { client } from '../../../common/js/alioss'
import zbList from "../../../components/zbList/zbList.vue"
import kong from "../../../components/kong/kong.vue"
import Cookies from 'js-cookie';
export default {
  name: 'shouye',
  components: {
    zbList,
	kong
  },
  data() {
    return {
	  navList:[],
	  navListIndex:0,
	  topNavIndex:0,
	  videoCateIndex:0,
	  videoCateList:[
		// isHost 语义对齐后端：0=全部(非热门)，1=热门
		{categoryName:this.$t('all.quanbu'), id:0},
		{categoryName:this.$t('all.remen'), id:1}
	  ],
      queryParams:{
      	page:1,
      	size:20,
      	categoryId:'',
		keyWord:''
      },
	  list:[],
	  hasMore: true,
	  isLoading: false,
	  isKong:false,
	  stateMonitor:null,
	  appConfigInfo:null,
	  // 首页视频网格数据
	  videoList:[],
	  videoPage:1,
	  videoSize:20,
	  videoHasMore:true,
	  videoLoading:false,
	  videoLoaded:false,
	  videoCateId:0 // isHost 语义：0=全部，1=热门
    };
  },
  created() {
	
  },
  mounted() {
	sessionStorage.setItem('user', 1);
	this.stateMonitor = setInterval(() => {
      const currentValue = this.$store.state.searchQuery;
    }, 10000);
	this.queryParams.page = 1
    this.getLiveCategoryList()
	this.$store.commit('changeCount', 2);
	this.checkIsLogin()
	this.getAppConfigInfo()
	// 短视频 tab 提前拉一批数据，用户切到 tab 时立即可见
	this.loadVideoList();
  },
  beforeDestroy() {
	clearInterval(this.stateMonitor);
	this.$store.commit('changeSearchQuery', null);
  },
  computed:{
	  topNavList(){
		// 顶级导航：直播(直播列表)；videoStatus=1 时才显示短影音
		const list = [this.$t('all.zhibo')]
		if (this.appConfigInfo && this.appConfigInfo.videoStatus == 1) {
			list.push(this.$t('all.duanyingyin'))
		}
		return list
	  },
	  searchQuery(){
		return this.$store.state.searchQuery
	  }
  },
  watch: {
      searchQuery: {
          handler(newValue, oldValue) {
              if (newValue !== oldValue || oldValue === undefined) {
                  this.queryParams.keyWord = newValue;
                  this.queryParams.page = 1;
                  this.hasMore = true;
                  this.getLiveCategoryList(); 
              }
          },
          immediate: true
      },
      // 短视频分类切换：重置分页重拉第一页
      videoCateIndex() {
          this.videoPage = 1;
          this.videoHasMore = true;
          this.videoList = [];
          this.videoLoaded = false;
          this.videoCateId = this.videoCateList[this.videoCateIndex].id;
          this.loadVideoList();
      }
  },
  methods: {
	//直播间分类
	getLiveCategoryList(){
		getLiveCategoryList().then(response => {
		  response.data.unshift({
		  	categoryName:this.$t('all.quanbu'),
		  	id:''
		  })
		  this.navList = response.data
		  this.queryParams.categoryId = response.data[0].id
		  this.getLiveList();
		});
	},
	//判断是否直播
	async checkIsLogin(){
		const res = await checkIsLogin()
		if(res.data == 0){
			this.$store.commit('changeToken', null);
			this.$store.commit('changeUserId', null); 
			this.$store.commit('changeUserInfo', null);
		}
	},
	//获取APP配置：videoStatus=1 时才显示短影音
	async getAppConfigInfo(){
		try {
			const res = await getAppConfigInfo()
			this.appConfigInfo = res.data
			// 若短影音未开启且当前停留在短影音tab，切回直播
			if (this.appConfigInfo && this.appConfigInfo.videoStatus != 1 && this.topNavIndex === 1) {
				this.topNavIndex = 0
			}
		} catch (e) {
			console.error('获取APP配置失败:', e)
		}
	},
	//切换顶级导航
	handleTopNav(index) {
		if (this.topNavIndex === index) return;
		this.topNavIndex = index;
	},
	//选择短视频分类(全部/热门)
	handleVideoCate(index) {
		if (this.videoCateIndex === index) return;
		this.videoCateIndex = index;
	},
	//选择直播分类
	handleNav(index) {
	    this.navListIndex = index
	    this.queryParams.page = 1;
	    this.queryParams.categoryId = this.navList[index].id;
	    this.hasMore = true;
	    this.getLiveList();
	},
    // 获取直播列表
	async getLiveList() {
	  if (this.isLoading || !this.hasMore) return;
	  try {
		this.isLoading = true;
		const response = await getLiveList(this.queryParams);
		const newList = response.rows || [];
		if (this.queryParams.page === 1) {
		  this.list = newList;
		} else {
		  this.list = [...this.list, ...newList];
		}
		const totalPages = Math.ceil((response.total || 0) / this.queryParams.size);
		this.hasMore = this.queryParams.page < totalPages;
        if(response.total == 0){
			this.isKong = true
		}else{
			this.isKong = false
		}
	  } catch (error) {
		console.error("获取直播列表失败:", error);
	  } finally {
		this.isLoading = false;
	  }
	},

	// 直播列表滚动加载更多
	handleScroll() {
	  if (this.isLoading || !this.hasMore) return;
	  const container = this.$refs.listContainer;
	  const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
	  if (isAtBottom) {
		this.queryParams.page++;
		this.getLiveList();
	  }
	},
	// 短视频网格滚动加载更多
	handleVideoScroll() {
	  if (this.videoLoading || !this.videoHasMore) return;
	  const container = this.$refs.videoGridContainer;
	  if (!container) return;
	  const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50;
	  if (isAtBottom) {
		this.videoPage++;
		this.loadVideoList();
	  }
	},
	// 加载首页视频流（全部 isHost=0 / 热门 isHost=1）
	async loadVideoList() {
	  if (this.videoLoading || !this.videoHasMore) return;
	  this.videoLoading = true;
	  try {
		// 接口：getVideoList，参数对齐 Swagger
		// isHost: 0=全部(非热门)，1=热门；title: 搜索关键词（模糊搜索标题）
		const res = await getVideoList({
		  page: this.videoPage,
		  size: this.videoSize,
		  isHost: this.videoCateId,
		  title: this.searchQuery || ''
		});
		const data = res.rows || res.data || [];
		const newList = Array.isArray(data) ? data : [];
		if (this.videoPage === 1) {
		  this.videoList = newList;
		} else {
		  this.videoList = [...this.videoList, ...newList];
		}
		const total = (res.total || newList.length);
		const totalPages = Math.ceil(total / this.videoSize);
		this.videoHasMore = this.videoPage < totalPages;
	  } catch (e) {
		console.error('加载短视频列表失败:', e);
	  } finally {
		this.videoLoading = false;
		this.videoLoaded = true;
	  }
	},
	// 跳转到播放详情页（首页短视频：公共视频流，不传 userId；传 videoId 定位 + isHost 保持全部/热门分类）
	handlePlayVideo(item) {
	  const videoId = item.videoId || item.id || '';
	  if (!videoId) return;
	  // isHost 语义：0=全部，1=热门（对齐后端 getVideoList 接口）
	  const isHost = this.videoCateList[this.videoCateIndex].id;
	  this.$router.push({ path: '/bofangshipin', query: { videoId, isHost } });
	},
	// 视频时长秒 → mm:ss
	formatDuration(seconds) {
	  if (!seconds) return '00:00';
	  const mins = Math.floor(seconds / 60);
	  const secs = Math.floor(seconds % 60);
	  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
	}
  }
};
</script>
<style scoped lang="scss">
	@import "./shouye.css";
</style>


// WEBPACK FOOTER //
// shouye.vue?69ecc4d3